// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"25402c4f","186":"8683cd55","272":"f0a17c2e","372":"0845beae","738":"baff68c9","841":"25d097e8","851":"3924b68d","856":"326561a4"}[chunkId] + ".chunk.js";
};